import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// Each area is one entry in the initial bundle: its module (fetched on the first
// visit) declares the area's screens, which are each their own chunk. This keeps
// the 20-odd course, community and portal screens out of the initial route table.
const CoursesRoutes = lazyRoute(() => import('./CoursesRoutes').then((m) => m.CoursesRoutes));
const CommunitiesRoutes = lazyRoute(() => import('../communities/CommunitiesPages').then((m) => m.CommunitiesRoutes));
const PortalRoutes = lazyRoute(() => import('../portal/PortalRoutes').then((m) => m.PortalRoutes));
const CertificatePage = lazyRoute(() => import('../portal/PortalAccount').then((m) => m.CertificatePage));

/** Courses (staff), under /agencies/:agencyId/courses */
export const coursesAgencyRoutes = <Route path="courses/*" element={<CoursesRoutes />} />;

/** Communities (staff), under /agencies/:agencyId/communities */
export const communitiesAgencyRoutes = <Route path="communities/*" element={<CommunitiesRoutes />} />;

/** The member portal and certificate pages (no staff sign-in) */
export const portalPublicRoutes = [
  <Route key="certificate" path="/certificates/:code" element={<CertificatePage />} />,
  <Route key="portal" path="/portal/*" element={<PortalRoutes />} />,
];
